<template lang="pug">
#modal-visualizacao-infos
    el-dialog(
        :title="$t('mensagens.preAnaliseCredito.informacoes')",
        :width='width',
        :visible='show',
        @close='closeDialog()'
    )
        slot

        .dialog-footer(slot='footer', v-if='mostrarBotaoVoltar')
            BaseButton(type='primary', @click='closeDialog()') {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import BaseButton from './BaseButton.vue';
export default {
    name: 'BaseModalVisualizarInfos',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        width: {
            type: String,
            default: '500px'
        },
        mostrarBotaoVoltar: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {};
    },

    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        }
    }
};
</script>

<style lang="scss">
#modal-visualizacao-infos {
    .el-dialog__footer {
        margin-top: 0px;
        text-align: right;
    }
    .el-dialog__body {
        max-height: 525px;
        overflow-y: auto;
    }
}
</style>
